require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./energie-edey-2-3-4-7.json") })
        }
      }, "path---energie-edey-2-3-4-7");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---energie-edey-2-3-4-7!./.cache/json/energie-edey-2-3-4-7.json
// module id = 407
// module chunks = 231608221292675